/**
 * Not Found (404) page API service
 */

import { fetchStrapi } from './strapi';

export interface NotFoundPage {
  heading: string;
  description: string;
  buttonText: string;
  buttonLink: string;
}

/**
 * Fetch 404 page data from Strapi
 */
export async function fetchNotFoundPage(): Promise<NotFoundPage | null> {
  try {
    const response = await fetchStrapi<any>('/nicht-gefunden');

    if (!response.data) {
      return null;
    }

    const data = response.data;

    return {
      heading: data.ueberschrift || '',
      description: data.beschreibung || '',
      buttonText: data.buttonText || '',
      buttonLink: data.buttonLink || '',
    };
  } catch (error) {
    console.error('Error fetching not-found page from Strapi:', error);
    return null;
  }
}
